import { loadExternalCreds } from '../modules/dashboard/components/DeveloperSettings';

/** Strip `nauk_at=…` / `li_at=…` if the user pasted a full Cookie header value. */
function normalizeCookieToken(raw: string, cookieName: string): string {
  let v = raw.trim();
  const fromCookie = v.match(new RegExp(`(?:^|;\\s*)${cookieName}=([^;]+)`, 'i'));
  if (fromCookie?.[1]) v = fromCookie[1].trim();
  if (v.startsWith('"') && v.endsWith('"')) v = v.slice(1, -1);
  return v;
}

/** Credentials for search-jobs-external / refresh-job-feeds (browser localStorage). */
export function buildJobSearchCredentials(): {
  linkedin_li_at?: string;
  naukri_nauk_at?: string;
  indeed_indeed_ssl?: string;
  internshala_session?: string;
} {
  const out: Record<string, string> = {};
  for (const c of loadExternalCreds()) {
    if (!c.key || !c.value?.trim()) continue;
    let val = c.value.trim();
    if (c.key === 'naukri_nauk_at') val = normalizeCookieToken(val, 'nauk_at');
    if (c.key === 'linkedin_li_at') val = normalizeCookieToken(val, 'li_at');
    out[c.key] = val;
  }
  return {
    linkedin_li_at: out.linkedin_li_at,
    naukri_nauk_at: out.naukri_nauk_at,
    indeed_indeed_ssl: out.indeed_indeed_ssl,
    internshala_session: out.internshala_session,
  };
}

export function hasNaukriJobCredential(): boolean {
  return Boolean(buildJobSearchCredentials().naukri_nauk_at);
}
